<template>
  <div style="height: 20vh">
    <!-- <div class="title" style="height: 10%">D7 Read Across</div> -->
    <div style="height: 100%;" class="bad-scroll">
      <table class="table-wrapper"> 
        <thead>
          <tr
            style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
            <th style="height:30px" width="70%">Lesson Learned</th>
            <th style="height:30px">Lesson Status</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(me, i) in dataList">
            <tr style="height:4vh;">
              <td :key="i">{{ me.title }}</td>
              <td>{{ me.status == 'true' ? 'Done' : 'Underway'}}</td>
            </tr>
          </template>
          <template v-if="dataList.length < 5">
            <tr style="height:4vh;" v-for="(me, i) in (5 - dataList.length)" :key="i">
              <td></td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "fr7d",
  props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["d7"]) {
          this.dataList = val["lessons"] || [];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList: {},
      startCharts: null,
    };
  },
  mounted() { },
  methods: {
    removeTAG(str) {
      if (str) {
        return str.replaceAll("\t", "&nbsp;&nbsp;").replaceAll("\n", "<br/>");
      } else {
        return str;
      }
    },
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper>thead>tr>th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 13px;
}

.table-wrapper>tbody>tr>td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  font-weight: bold;
  padding: 4px 0;
  text-align: center;
  font-size: 13px;
}

.bad-scroll {
  overflow-y: auto
}

.bad-scroll::-webkit-scrollbar {
  width: 4px;
  height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #909090;
}

.bad-scroll::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/8d/component/7d.vue